
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/[slug]",
      function () {
        return require("private-next-pages/jobs/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/[slug]"])
      });
    }
  